<ng-container *ngIf="showLayout">
  <mat-toolbar id="navigation">
    <mat-toolbar-row>
      <div>
        <a mat-icon-button (click)="onToggleSidenav()">
          <mat-icon>menu</mat-icon>
        </a>
      </div>

      <div id="container-nav">
        <div id="logo">
          <img
            id="logo2"
            style="padding-top: 0.35rem"
            width="148"
            height="45"
            src="assets/logos/Logo_VidaSecurityBice.png"
          />
        </div>

        <nav class="main-nav" *ngIf="isLoggedIn$ | async as isLoggedIn">
          <a
            mat-button
            *ngIf="visibilityPagarProductos"
            (click)="pagarProductos()"
          >
            <svg-icon
              src="../../../assets/icons/credit-card.svg"
              [svgStyle]="{
                'width.rem': 1,
                'height.rem': 0.7,
                position: 'relative',
                'top.rem': 0.1
              }"
            ></svg-icon>
            <span class="responsive-hide">Pagar mis Productos</span>
          </a>

          <a mat-button *ngIf="showInfome" (click)="goInformeRentabilidad()">
            <mat-icon aria-hidden="false" aria-label="Example home icon"
              >trending_up</mat-icon
            >

            <span class="responsive-hide">Informe de Rentabilidad</span>
          </a>

          <a mat-button [matMenuTriggerFor]="menu" #t="matMenuTrigger">
            <span></span>
            <svg-icon
              src="../../../assets/icons/user.svg"
              [svgStyle]="{
                'width.rem': 0.782,
                'height.rem': 0.82,
                position: 'relative',
                'top.rem': 0.15
              }"
            ></svg-icon>
            <!-- <mat-icon>account_circle</mat-icon> -->
            <span class="hi responsive-hide">Hola, </span>
            <span class="responsive-hide">{{ username }}</span>
            <svg-icon
              [ngClass]="{ rotateMenuIcon: t.menuOpen }"
              src="../../../assets/icons/arrow_down.svg"
              [svgStyle]="{
                'width.rem': 0.65,
                'height.rem': 0.3,
                'paddingLeft.rem': 0.32,
                position: 'relative',
                'bottom.rem': 0.05
              }"
            ></svg-icon>
          </a>
          <mat-menu [xPosition]="'before'" #menu="matMenu">
            <button mat-menu-item (click)="misDatos()">
              <span>Mis Datos</span>
            </button>
            <button mat-menu-item (click)="cambiarContrasena()">
              <span>Cambiar Contraseña</span>
            </button>
            <button mat-menu-item (click)="logout()">
              <span>Cerrar Sesión</span>
            </button>
          </mat-menu>
        </nav>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-sidenav-container>
    <mat-sidenav
      *ngIf="isLoggedIn$ | async as isLoggedIn"
      #sidenav
      [mode]="over"
      [opened]="opened"
      role="navigation"
      class="side-nav"
    >
      <span class="title">{{ mainMenu.title }}</span>
      <mat-accordion>
        <mat-expansion-panel
          *ngFor="let item of mainMenu.items; index as i"
          [expanded]="item.active"
          class="panel-margin"
          hideToggle
          [disabled]="true"
        >
          <mat-expansion-panel-header
            (click)="lostFocus($event, item)"
            class="custom-expansion-panel-header"
          >
            <mat-panel-title>
              {{ item.route.label.toLocaleUpperCase() }}
            </mat-panel-title>
            <svg-icon
              [ngClass]="{ rotateIcon: item.active }"
              src="../../../assets/icons/arrow_down_filled.svg"
              [svgStyle]="{
                'width.rem': 0.65,
                'height.rem': 0.3
              }"
            ></svg-icon>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a
              class="menu-slide-item"
              [ngClass]="{ 'menu-slide-item-active': child.active }"
              (click)="navigateTo(item, child)"
              mat-list-item
              *ngFor="let child of item.children"
            >
              <h3 matLine>
                {{ child.label }}<br />
                <div *ngIf="child.item?.PolizaDescripcion; else other_content">
                  {{ child.item.PolizaDescripcion }}
                </div>
                <ng-template #other_content>{{
                  child.item.Poliza
                }}</ng-template>
              </h3>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>
        <div class="menu-img">
          <a
            *ngIf="visibleTelemed"
            (click)="goTelemed()"
            target="_blank"
            style="cursor:pointer;"
          >
            <img
              src="../../../assets/img/Caluga-Telemedicina-Sucursal-Virtual.jpg"
              alt="Telemedicina"
              width="99%"
            />
          </a>
        </div>
        <!--Banner BHP, se muestra segun informacion de links-->
        <div class="menu-img">
          <a
            *ngIf="visibleBHP"
            [href]="urlBHP"
            target="_blank"
            style="cursor:pointer;"
          >
            <img
              src="../../../assets/img/Caluga-BHP-Sucursal-Virtual.jpg"
              alt="Beneficios BHP"
              width="99%"
            />
          </a>
        </div>
        <!------------------------------------------------->
        <div class="menu-img">
          <a
            *ngIf="visible"
            (click)="goOncologico()"
            target="_blank"
            style="cursor:pointer;"
          >
            <img
              src="../../../assets/img/bannerOncologico.png"
              alt="Seguro Oncologico"
              width="99%"
            />
          </a>
        </div>
        <div class="menu-img">
          <a (click)="goClubViva()" target="_blank" style="cursor:pointer;">
            <img
              src="../../../../assets/img/Caluga-Club-Sucursal-Virtual.jfif"
              alt="Club viva"
              width="99%"
            />
          </a>
        </div>
        <div class="menu-img">
          <a
            *ngIf="visibleChanchito"
            (click)="goChanchito(firstChildChanchito, 'aporte')"
            target="_blank"
            style="cursor:pointer;"
          >
            <img
              src="../../../assets/img/Gif_Chanchito.gif"
              alt="Ahorro Esporadico"
              width="99%"
            />
          </a>
        </div>
      </mat-accordion>
    </mat-sidenav>

    <mat-sidenav-content [ngClass]="{ 'content-framing': isLoggedIn$ | async }">
      <div>
        <div class="app-site-map-navigator">
          <app-site-map-navigator
            *ngIf="verifyRoute() && isLoggedIn$ | async"
          ></app-site-map-navigator>
        </div>
        <router-outlet> </router-outlet>
      </div>
      <div class="footer">
        <p class="terminos" (click)="showTerms()">Ver términos y condiciones</p>
        © 2020 Vida Security. Todos los derechos reservados.
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>

<ng-container *ngIf="!showLayout">
  <router-outlet></router-outlet>
</ng-container>
